<template>
  <v-dialog
    v-model="show"
    width="800px"
  >
    <div class="dialog-container">
      <div class="dialog-header">
        <p>Join Team</p>
        <font-awesome-icon
          icon="times"
          class="pointer"
          @click="handleCancel"></font-awesome-icon>
      </div>
      <div class="dialog-body">
        <team-list
          is-select-team
          :teamGroupId.sync="team_group_id"
          :teamGroupName.sync="team_group_name"
        >
        </team-list>
        <div class="btn-list flex-sb-center">
          <v-button
            gray
            @click="handleCancel">Cancel</v-button>
          <v-button
            green
            @click="handleConfirm">Confirm</v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import TeamList from '@/views/records/referrerReward/team/list'
import {joinSpecialTeam} from '@api/team'
export default {
  components:{
    TeamList
  },
  props:{
    value: {
      type: Boolean,
      default: false
    },
    customerId: {
      type: Number,
      default: 0
    },
  },
  data () {
    return {
      show: false,
      team_group_id:'',
      team_group_name:'',
    }
  },
  computed:{
  },
  watch: {
    value:{
      immediate:true,
      handler(val){
        this.show = val
        if(val){
        }
      }
    },
  },
  methods: {
    handleCancel(){
      this.show = false
      this.$emit('input',false)
    },
    handleConfirm(){
      if(this.team_group_id){
        this.network().joinSpecialTeam()
      }
    },
    network(){
      return{
        joinSpecialTeam:async ()=>{
          let {data} = await joinSpecialTeam({
            team_group_id:this.team_group_id,
            name:this.team_group_name,
            user_id:this.customerId
          })
          this.$emit('update')
          this.$emit('input',false)
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.dialog-container{
  .dialog-header{
    height: 20px;
    padding: 16px;
    box-sizing: content-box;
    display: flex;
    justify-content: space-between;
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #1B1F23;
  }
  .dialog-body{
    padding: 20px 25px 15px 25px;
    .qrcode{
      position: relative;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      .qr-box{
        padding: 15px;
        background: #fff;
        position: relative;
        display: flex;
        justify-content: center;
      }
      .qr_avatar{
        display: flex;
        justify-content: center;
        width: 58px;
        height: 58px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        border: 4px solid #fff;
        background-color: #fff;
        border-radius: 50%;
        overflow: hidden;
        z-index: 2;
      }
    }
    .info{
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 20px;
      .link{
        color: #000000;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 10px;
      }
      .blue{
        color: #0366D6;
      }
    }
    .btn-list{
      margin-top: 20px;
      text-align: right;
      .red{
        color: #CB2431;
      }
    }
  }
}

</style>
